import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../../../components/Seo/seo'
import { FormattedMessage, useIntl } from 'react-intl'
import Layout from '../../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../../routes'
import { addCategory } from '../../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { CategoryProvider } from '../../../../CategoryContext'
import { FormLoader } from '../../../../components/Loader/FormLoader'
import CategoryEditContent from '../../../../components/Dashboard/Subscription/CategoryEditContent'


const SingleCategoryAdd = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Categories.List.AddCategory.Title' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={addCategory.image}
           description={intl.formatMessage({ id: 'Categories.List.AddCategory.Title' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ? <Layout content={
                <CategoryProvider pageAction={'add'} handleNotificationCall={handleNotificationCall}>
                  <CategoryEditContent pageTitle={<FormattedMessage id='Categories.List.AddCategory.Title'/>}/>
                </CategoryProvider>
              }/> : (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default SingleCategoryAdd

